/**
 * Supporting-feature card for Family Gathering Room (not a fourth pillar).
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import { Button } from '../ui/button';
import { helpSectionHref } from '../../content/helpGuidesContent';
import { FAMILY_GATHERING_ROOM_CARD } from '../../content/familyGatheringRoomContent';
import { FamilyGatheringRoomRequestModal } from './FamilyGatheringRoomRequestModal';

export function FamilyGatheringRoomCard({ className = '' }) {
  const [modalOpen, setModalOpen] = useState(false);
  const copy = FAMILY_GATHERING_ROOM_CARD;

  return (
    <>
      <section
        className={`rounded-2xl border border-[hsl(38_16%_82%)]/70 bg-[#fffdf8]/90 px-5 py-4 sm:px-6 ${className}`}
        data-testid="family-gathering-room-card"
        aria-labelledby="family-gathering-room-heading"
      >
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0 space-y-2">
            <p className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.14em] text-[#8b7355]">
              <Users className="h-3.5 w-3.5" aria-hidden />
              Supporting benefit
            </p>
            <h2 id="family-gathering-room-heading" className="font-serif text-lg font-light text-[#1c1917] sm:text-xl">
              {copy.title}
            </h2>
            <p className="max-w-2xl text-sm leading-relaxed text-[#5c534a]">{copy.description}</p>
            <p className="text-xs leading-relaxed text-[#7a7268]">{copy.availability}</p>
          </div>
          <div className="flex shrink-0 flex-col gap-2 sm:items-end">
            <Button
              type="button"
              className="rounded-full bg-[#8B7355] text-white hover:bg-[#7A6548]"
              onClick={() => setModalOpen(true)}
              data-testid="gathering-room-request-btn"
            >
              {copy.primaryCta}
            </Button>
            <Button asChild variant="ghost" size="sm" className="rounded-full text-[#5c534a]" data-testid="gathering-room-how-it-works">
              <Link to={helpSectionHref('family-gathering-room')}>{copy.secondaryCta}</Link>
            </Button>
          </div>
        </div>
      </section>

      <FamilyGatheringRoomRequestModal open={modalOpen} onOpenChange={setModalOpen} />
    </>
  );
}

export default FamilyGatheringRoomCard;
